/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: agentsActions.ts (Agents)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Shared helpers for Agents module actions.
    Used in Grid + Form views.

 🔧 Notes:
    - Refactored to use new API layer
    - Navigation helpers for duplicate functionality

 🔁 Last Updated: 2025-01-15 by Rodrigo Cuadra (Refactored)
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteAgentById as deleteAgentApi } from './api/agentsApi';

/**
 * Build the URL used to duplicate an Agent in the form.
 * Pattern: /pbx/call-center/agents/new?duplicate={id}
 */
export const getAgentDuplicateUrl = (id: string | number): string =>
  `/pbx/call-center/agents/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Agent id.
 */
export const navigateToAgentDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getAgentDuplicateUrl(id));
};

/**
 * Delete an Agent by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteAgentById = async (id: string | number): Promise<void> => {
  await deleteAgentApi(id);
};



